document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pdp-gallery-viewer').forEach(function (viewer) {
    var dots = viewer.querySelectorAll('.pdp-gallery-dot');
    if (!dots.length) return;

    viewer.addEventListener('slideChanged', function (e) {
      var page = e.detail.currentPage;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i + 1 === page);
      });
    });

    var slider = viewer.querySelector('[id^="Slider-"]');
    var slides = slider ? Array.from(slider.querySelectorAll('[id^="Slide-"]')) : [];
    dots.forEach(function (dot, i) {
      dot.style.cursor = 'pointer';
      dot.addEventListener('click', function () {
        var target = slides[i];
        if (!target || !slider) return;
        slider.scrollTo({ left: target.offsetLeft, behavior: 'instant' });
      });
    });
  });

  syncThumbHeight();
});

window.addEventListener('resize', syncThumbHeight);

function syncThumbHeight() {
  if (window.innerWidth < 750) return;
  document.querySelectorAll('media-gallery').forEach(function (gallery) {
    var activeMedia = gallery.querySelector('.pdp-gallery-viewer .product__media-item.is-active .media');
    var thumbSlider = gallery.querySelector('.pdp-gallery-thumbs');
    if (!activeMedia || !thumbSlider) return;
    var h = activeMedia.getBoundingClientRect().height;
    if (h > 0) thumbSlider.style.maxHeight = h + 'px';
  });
}
